export const polyhouseImages = [
  {
    length: 8,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759812029/polyhouse-foundation_8mX20m_noswud.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 8,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759812029/polyhouse-foundation_8mX20m_noswud.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 8,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759812754/polyhouse-foundation_8mX36m_fx6dqi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 8,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759812754/polyhouse-foundation_8mX44m_iovkje.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 8,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759812754/polyhouse-foundation_8mX52m_hqxwbz.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 8,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759812754/polyhouse-foundation_8mX60m_n9hg8g.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 8,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759812754/polyhouse-foundation_8mX68m_hnjuys.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 8,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759812755/polyhouse-foundation_8mX76m_odkrib.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 8,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759812755/polyhouse-foundation_8mX84m_u2g8wk.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 8,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759813698/polyhouse-foundation_8mX92m_if8jjv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 8,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759813698/polyhouse-foundation_8mX100m_dofkuk.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 8,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759813698/polyhouse-foundation_8mX108m_o6l7sd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 8,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759813699/polyhouse-foundation_8mX116m_ae0mzp.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 8,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759813699/polyhouse-foundation_8mX124m_p5og1q.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 8,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759813699/polyhouse-foundation_8mX132m_ukobzf.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 8,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759813700/polyhouse-foundation_8mX140m_abuozm.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 8,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759813697/polyhouse-foundation_8mX148m_wflsbg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 12,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814365/polyhouse-foundation_12mX20m_lcn4jk.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 12,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814393/polyhouse-foundation_12mX28m_ijwtv7.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 12,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814393/polyhouse-foundation_12mX36m_wcxrtn.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 12,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814393/polyhouse-foundation_12mX44m_elohhs.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 12,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814397/polyhouse-foundation_12mX52m_zbxoye.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 12,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814398/polyhouse-foundation_12mX60m_zoygzg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 12,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814399/polyhouse-foundation_12mX68m_niih6s.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 12,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814401/polyhouse-foundation_12mX76m_j7klv1.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 12,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814401/polyhouse-foundation_12mX76m_j7klv1.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 12,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814404/polyhouse-foundation_12mX92m_x6wvgh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 12,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814405/polyhouse-foundation_12mX100m_x3hcor.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 12,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814408/polyhouse-foundation_12mX108m_mqf0ep.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 12,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814409/polyhouse-foundation_12mX116m_zzcvg7.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 12,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814412/polyhouse-foundation_12mX124m_hffexl.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 12,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814413/polyhouse-foundation_12mX132m_vq1o4j.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 12,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814415/polyhouse-foundation_12mX140m_schg3x.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 12,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759814419/polyhouse-foundation_12mX148m_sqcczk.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 16,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815890/polyhouse-foundation_16mX20m_1_plit6h.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 16,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815890/polyhouse-foundation_16mX28m_2_nevghh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 16,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815892/polyhouse-foundation_16mX36m_qcqfzv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 16,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815891/polyhouse-foundation_16mX44m_awe2zd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 16,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815900/polyhouse-foundation_16mX52m_msgrsb.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 16,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815899/polyhouse-foundation_16mX60m_jrlote.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 16,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815900/polyhouse-foundation_16mX68m_sr138z.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 16,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815901/polyhouse-foundation_16mX76m_zduzum.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 16,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815910/polyhouse-foundation_16mX84m_ddmltf.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 16,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815911/polyhouse-foundation_16mX92m_q7h1g3.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 16,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815912/polyhouse-foundation_16mX100m_pjtdbp.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 16,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815921/polyhouse-foundation_16mX108m_jrmpz7.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 16,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815922/polyhouse-foundation_16mX116m_e85pjy.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 16,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815922/polyhouse-foundation_16mX124m_cexdj2.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 16,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815928/polyhouse-foundation_16mX132m_lj9jbe.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 16,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815929/polyhouse-foundation_16mX140m_lrfp8q.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 16,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759815890/polyhouse-foundation_16mX148m_jlm161.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 20,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817757/polyhouse-foundation_20mX20m_wmxkbc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 20,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817757/polyhouse-foundation_20mX28m_vb0aiv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 20,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817757/polyhouse-foundation_20mX36m_qv1ziz.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 20,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817757/polyhouse-foundation_20mX44m_pvweyg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 20,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817757/polyhouse-foundation_20mX52m_uyblcr.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 20,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817757/polyhouse-foundation_20mX60m_np6ewo.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 20,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817758/polyhouse-foundation_20mX68m_azfv8d.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 20,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817758/polyhouse-foundation_20mX76m_ppe5h4.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 20,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817758/polyhouse-foundation_20mX84m_rwagr6.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 20,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817759/polyhouse-foundation_20mX92m_p9p2ba.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 20,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817759/polyhouse-foundation_20mX100m_lqo47o.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 20,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817759/polyhouse-foundation_20mX108m_pnfwmy.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 20,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817759/polyhouse-foundation_20mX116m_ujspmm.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 20,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817759/polyhouse-foundation_20mX124m_aqikdg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 20,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817760/polyhouse-foundation_20mX132m_a5t9gu.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 20,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817760/polyhouse-foundation_20mX140m_oh6iwn.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 20,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817760/polyhouse-foundation_20mX148m_u8qapc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 24,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817760/polyhouse-foundation_24mX20m_3_g3iqnc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 24,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817760/polyhouse-foundation_24mX28m_xilo1g.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 24,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759818385/polyhouse-foundation_24mX36m_lhepfi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 24,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817760/polyhouse-foundation_24mX44m_n1ynww.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 24,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817760/polyhouse-foundation_24mX52m_vi8vrb.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 24,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817761/polyhouse-foundation_24mX60m_cbrch5.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 24,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817761/polyhouse-foundation_24mX68m_kkwc1t.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 24,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817761/polyhouse-foundation_24mX76m_lw4dx9.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 24,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817761/polyhouse-foundation_24mX84m_tprpvq.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 24,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817765/polyhouse-foundation_28mX92m_1_fbu5ns.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 24,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817761/polyhouse-foundation_24mX100m_b5nqhg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 24,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817762/polyhouse-foundation_24mX108m_j4gzrk.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 24,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817762/polyhouse-foundation_24mX116m_lm2ftd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 24,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817762/polyhouse-foundation_24mX124m_eyq6en.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 24,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817762/polyhouse-foundation_24mX132m_mmiieg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 24,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817762/polyhouse-foundation_24mX140m_e3xuot.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 24,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817763/polyhouse-foundation_24mX148m_l6gxef.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 28,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817763/polyhouse-foundation_28mX20m_ivk7dm.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 28,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817763/polyhouse-foundation_28mX28m_quswkj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 28,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817763/polyhouse-foundation_28mX36m_ms1kwq.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 28,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817764/polyhouse-foundation_28mX44m_q8ztvj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 28,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817764/polyhouse-foundation_28mX52m_1_pcmkgx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 28,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817764/polyhouse-foundation_28mX60m_wdasev.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 28,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817764/polyhouse-foundation_28mX68m_tdjzui.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 28,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817765/polyhouse-foundation_28mX76m_gajzwx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 28,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817765/polyhouse-foundation_28mX84m_twlf0e.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 28,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817816/polyhouse-foundation_28mX92m_nsmiql.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 28,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817817/polyhouse-foundation_28mX100m_a5c3as.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 28,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817817/polyhouse-foundation_28mX108m_ngfpyj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 28,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817817/polyhouse-foundation_28mX116m_mreurv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 28,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817817/polyhouse-foundation_28mX124m_pb53aj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 28,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817817/polyhouse-foundation_28mX132m_qv5dmy.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 28,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817817/polyhouse-foundation_28mX140m_jibnde.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 28,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759817820/polyhouse-foundation_28mX148m_cte5qm.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 32,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823864/polyhouse-foundation_32mX20m_j7j7ad.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 32,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823865/polyhouse-foundation_32mX28m_u5przd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 32,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823865/polyhouse-foundation_32mX36m_duh314.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 32,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823865/polyhouse-foundation_32mX44m_xauxxo.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 32,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823865/polyhouse-foundation_32mX52m_ofcqlz.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 32,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823865/polyhouse-foundation_32mX60m_aklftg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 32,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823865/polyhouse-foundation_32mX68m_xt9uqo.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 32,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823865/polyhouse-foundation_32mX76m_x9n1vg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 32,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823866/polyhouse-foundation_32mX84m_mjscw1.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 32,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823866/polyhouse-foundation_32mX92m_sqi6ov.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 32,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823866/polyhouse-foundation_32mX100m_c3awk8.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 32,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823866/polyhouse-foundation_32mX108m_pplk8c.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 32,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823866/polyhouse-foundation_32mX116m_iv58jj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 32,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823883/polyhouse-foundation_32mX124m_oee3de.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 32,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759828946/polyhouse-foundation_32mX148m_jfm4xo.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 32,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759828948/polyhouse-foundation_32mX140m_regivw.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 32,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759828948/polyhouse-foundation_32mX140m_regivw.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 36,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823883/polyhouse-foundation_36mX20m_et1oii.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 36,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823884/polyhouse-foundation_36mX28m_fddwva.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 36,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823884/polyhouse-foundation_36mX36m_y2uekh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 36,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823892/polyhouse-foundation_36mX44m_vkfll1.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 36,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823892/polyhouse-foundation_36mX52m_rsajnl.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 36,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823892/polyhouse-foundation_36mX60m_fokwnw.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 36,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823893/polyhouse-foundation_36mX68m_s89clp.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 36,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823901/polyhouse-foundation_36mX76m_opqm6g.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 36,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823902/polyhouse-foundation_36mX84m_xgkjyc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 36,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823902/polyhouse-foundation_36mX92m_h6ov4s.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 36,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823903/polyhouse-foundation_36mX100m_x5lgfd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 36,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823903/polyhouse-foundation_36mX108m_o4rgbh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 36,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823913/polyhouse-foundation_36mX116m_fecaxq.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 36,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823914/polyhouse-foundation_36mX124m_evjomo.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 36,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823914/polyhouse-foundation_36mX132m_pexvnc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 36,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823915/polyhouse-foundation_36mX140m_rjnvhx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 36,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823916/polyhouse-foundation_36mX148m_lqqyue.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 40,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823915/polyhouse-foundation_40mX20m_u3jmh8.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 40,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823915/polyhouse-foundation_40mX28m_xrvcgk.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 40,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823916/polyhouse-foundation_40mX36m_f7bufp.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 40,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823932/polyhouse-foundation_40mX44m_mp7mse.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 40,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823933/polyhouse-foundation_40mX52m_fmoxsx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 40,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823933/polyhouse-foundation_40mX60m_vs7ibe.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 40,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823941/polyhouse-foundation_40mX68m_pun12d.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 40,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823942/polyhouse-foundation_40mX76m_x13pgg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 40,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823942/polyhouse-foundation_40mX84m_hi00a9.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 40,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823944/polyhouse-foundation_40mX92m_rxqohm.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 40,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823950/polyhouse-foundation_40mX100m_evx2wq.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 40,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823950/polyhouse-foundation_40mX108m_ym6mbg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 40,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823950/polyhouse-foundation_40mX116m_au85bp.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 40,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823951/polyhouse-foundation_40mX124m_cjvgml.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 40,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823960/polyhouse-foundation_40mX132m_j0hpef.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 40,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823959/polyhouse-foundation_40mX140m_mkszcj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 40,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759823960/polyhouse-foundation_40mX148m_fzzrzg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 44,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759833972/polyhouse-foundation_44mX20m_s3qdyh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 44,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832620/polyhouse-foundation_44mX28m_madi8l.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 44,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832512/polyhouse-foundation_44mX36m_ilklxi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 44,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832512/polyhouse-foundation_44mX44m_cgmjb9.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 44,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832513/polyhouse-foundation_44mX52m_1_fflq6i.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 44,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832513/polyhouse-foundation_44mX60m_jazaac.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 44,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832514/polyhouse-foundation_44mX68m_ls1y02.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 44,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832526/polyhouse-foundation_44mX76m_nzrj53.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 44,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832527/polyhouse-foundation_44mX84m_u7yl0e.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 44,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832527/polyhouse-foundation_44mX92m_crzaxu.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 44,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832534/polyhouse-foundation_44mX100m_ymwddx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 44,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832534/polyhouse-foundation_44mX100m_ymwddx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 44,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832540/polyhouse-foundation_44mX116m_tvoml7.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 44,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832541/polyhouse-foundation_44mX124m_1_sumjum.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 44,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832548/polyhouse-foundation_44mX132m_p7vvc2.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 44,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832554/polyhouse-foundation_44mX140m_k4z8yg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 44,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832558/polyhouse-foundation_44mX148m_p8kpz6.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 48,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834982/polyhouse-foundation_48mX20m_oghtwm.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 48,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834975/polyhouse-foundation_48mX28m_wdbzdb.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 48,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834974/polyhouse-foundation_48mX36m_y9aufu.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 48,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834972/polyhouse-foundation_48mX44m_fbnmye.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 48,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834971/polyhouse-foundation_48mX52m_npihor.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 48,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834965/polyhouse-foundation_48mX60m_bp3ebs.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 48,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834963/polyhouse-foundation_48mX68m_bx4m1u.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 48,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834963/polyhouse-foundation_48mX68m_bx4m1u.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 48,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834959/polyhouse-foundation_48mX84m_n2wf4r.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 48,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834952/polyhouse-foundation_48mX92m_l79z1e.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 48,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834951/polyhouse-foundation_48mX100m_icjo0d.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 48,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834950/polyhouse-foundation_48mX108m_nyu2rx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 48,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834940/polyhouse-foundation_48mX116m_jym37e.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 48,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834939/polyhouse-foundation_48mX124m_zv2kao.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 48,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834939/polyhouse-foundation_48mX132m_pmaqzw.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 48,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832554/polyhouse-foundation_44mX140m_k4z8yg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 48,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759832558/polyhouse-foundation_44mX148m_p8kpz6.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 52,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835612/polyhouse-foundation_52mX20m_ciw10x.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 52,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835607/polyhouse-foundation_52mX28m_zzgpg5.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 52,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835602/polyhouse-foundation_52mX36m_vy9y6m.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 52,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835602/polyhouse-foundation_52mX44m_weuond.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 52,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835596/polyhouse-foundation_52mX52m_wcisgg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 52,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835595/polyhouse-foundation_52mX60m_kujlvc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 52,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835590/polyhouse-foundation_52mX68m_or2ze1.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 52,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835584/polyhouse-foundation_52mX76m_wurjnb.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 52,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835583/polyhouse-foundation_52mX84m_kssgfa.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 52,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835582/polyhouse-foundation_52mX92m_wg9t8e.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 52,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835574/polyhouse-foundation_52mX100m_ygfgs7.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 52,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835573/polyhouse-foundation_52mX108m_olb99w.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 52,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836081/polyhouse-foundation_52mX116m_lihmqj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 52,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835562/polyhouse-foundation_52mX124m_bqtx1t.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 52,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835562/polyhouse-foundation_52mX132m_ncsfxh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 52,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835561/polyhouse-foundation_52mX140m_xjaotu.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 52,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835561/polyhouse-foundation_52mX148m_jbegax.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 56,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836658/polyhouse-foundation_56mX20m_rvhwjq.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 56,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836657/polyhouse-foundation_56mX28m_kywbxi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 56,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836650/polyhouse-foundation_56mX36m_nfsx8n.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 56,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836650/polyhouse-foundation_56mX36m_nfsx8n.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 56,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836642/polyhouse-foundation_56mX52m_rvxs4u.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 56,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836641/polyhouse-foundation_56mX60m_xfp1fq.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 56,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1760003515/polyhouse-foundation_56mX68m_3_ncdcox.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 56,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759837478/polyhouse-foundation_56mX76m_i4uqwd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 56,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836635/polyhouse-foundation_56mX84m_rrq7tl.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 56,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836629/polyhouse-foundation_56mX92m_qc7vii.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 56,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836627/polyhouse-foundation_56mX100m_fvssbt.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 56,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836621/polyhouse-foundation_56mX108m_nkv1cg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 56,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836620/polyhouse-foundation_56mX116m_bnigib.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 56,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836611/polyhouse-foundation_56mX124m_jl37k6.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 56,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836612/polyhouse-foundation_56mX132m_cvwvj3.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 56,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836610/polyhouse-foundation_56mX140m_vxiivi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 56,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836610/polyhouse-foundation_56mX148m_p8xtzn.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 60,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838515/polyhouse-foundation_60mX20m_jijl2w.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 60,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838505/polyhouse-foundation_60mX28m_loy4vk.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 60,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838498/polyhouse-foundation_60mX36m_ncdhlx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 60,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838496/polyhouse-foundation_60mX44m_jetaji.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 60,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838491/polyhouse-foundation_60mX52m_gcdwl0.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 60,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838489/polyhouse-foundation_60mX60m_lsluqp.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 60,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838483/polyhouse-foundation_60mX68m_omfbj0.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 60,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838478/polyhouse-foundation_60mX76m_manjdh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 60,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838477/polyhouse-foundation_60mX84m_jlquiy.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 60,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838244/polyhouse-foundation_60mX92m_a58hus.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 60,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838201/polyhouse-foundation_60mX100m_wt0siq.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 60,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838193/polyhouse-foundation_60mX108m_f0bsul.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 60,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838192/polyhouse-foundation_60mX116m_shhr30.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 60,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838181/polyhouse-foundation_60mX124m_a8c7sj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 60,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838182/polyhouse-foundation_60mX132m_jphnrj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 60,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838180/polyhouse-foundation_60mX140m_y4aqvw.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 60,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838180/polyhouse-foundation_60mX148m_gfsv1p.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 64,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838587/polyhouse-foundation_64mX20m_p1hqvk.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 64,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838581/polyhouse-foundation_64mX28m_fu1s0d.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 64,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838579/polyhouse-foundation_64mX36m_u23k0f.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 64,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838574/polyhouse-foundation_64mX44m_xkqk2n.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 64,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838570/polyhouse-foundation_64mX52m_aqqn3y.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 64,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838566/polyhouse-foundation_64mX60m_wxg8c4.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 64,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838559/polyhouse-foundation_64mX68m_xp5gjh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 64,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838556/polyhouse-foundation_64mX76m_mtrkyz.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 64,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838554/polyhouse-foundation_64mX84m_kszjpv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 64,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838556/polyhouse-foundation_64mX92m_fliddl.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 64,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838548/polyhouse-foundation_64mX100m_bp92n8.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 64,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838543/polyhouse-foundation_64mX108m_axhk8d.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 64,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838540/polyhouse-foundation_64mX116m_fgfnwn.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 64,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838532/polyhouse-foundation_64mX124m_wwl4fu.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 64,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838531/polyhouse-foundation_64mX132m_eizgvu.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 64,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838522/polyhouse-foundation_64mX140m_p3mxgn.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 64,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838521/polyhouse-foundation_64mX148m_l2d8pt.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 68,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897754/polyhouse-foundation_68mX20m_yzbxnk.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 68,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897722/polyhouse-foundation_68mX28m_oo0sp5.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 68,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897722/polyhouse-foundation_68mX36m_wvmch0.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 68,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897722/polyhouse-foundation_68mX44m_tfkg1f.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 68,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897722/polyhouse-foundation_68mX52m_nruibv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 68,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897722/polyhouse-foundation_68mX60m_skrlit.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 68,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897722/polyhouse-foundation_68mX28m_oo0sp5.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 68,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897721/polyhouse-foundation_68mX76m_qxsiwh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 68,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897721/polyhouse-foundation_68mX84m_vllbv2.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 68,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897720/polyhouse-foundation_68mX92m_jqtfsv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 68,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897720/polyhouse-foundation_68mX100m_qxmglc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 68,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897722/polyhouse-foundation_68mX108m_ar70uz.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 68,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897721/polyhouse-foundation_68mX116m_vtvlcw.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 68,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897721/polyhouse-foundation_68mX124m_hxkxph.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 68,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897720/polyhouse-foundation_68mX132m_u07crx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 68,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897720/polyhouse-foundation_68mX140m_iabmsd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 68,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759897720/polyhouse-foundation_68mX148m_m4ow7w.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 72,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898901/polyhouse-foundation_72mX20m_jn4fnv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 72,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898896/polyhouse-foundation_72mX28m_lly6oe.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 72,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898894/polyhouse-foundation_72mX36m_csp12p.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 72,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898893/polyhouse-foundation_72mX44m_tfm5a8.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 72,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898888/polyhouse-foundation_72mX52m_abzpn3.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 72,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898887/polyhouse-foundation_72mX60m_frn3jh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 72,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898886/polyhouse-foundation_72mX68m_z5rj2t.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 72,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898880/polyhouse-foundation_72mX76m_jpckdt.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 72,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898879/polyhouse-foundation_72mX84m_thezmx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 72,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898879/polyhouse-foundation_72mX92m_oy9oqg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 72,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898867/polyhouse-foundation_72mX100m_kq3xqs.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 72,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898866/polyhouse-foundation_72mX108m_d3iboc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 72,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898867/polyhouse-foundation_72mX116m_okwivb.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 72,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898866/polyhouse-foundation_72mX124m_o7mbhi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 72,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898866/polyhouse-foundation_72mX132m_v7chaw.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 72,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898866/polyhouse-foundation_72mX140m_hlwicm.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 72,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898865/polyhouse-foundation_72mX148m_seqa9v.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 76,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900780/polyhouse-foundation_76mX20m_dztjdg.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 76,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900773/polyhouse-foundation_76mX28m_rla3q8.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 76,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900773/polyhouse-foundation_76mX36m_hzvrax.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 76,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900772/polyhouse-foundation_76mX44m_shq1st.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 76,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900763/polyhouse-foundation_76mX52m_pyaof9.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 76,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900762/polyhouse-foundation_76mX60m_zvkjli.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 76,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900762/polyhouse-foundation_76mX68m_frihze.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 76,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900761/polyhouse-foundation_76mX76m_ntvmyh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 76,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900754/polyhouse-foundation_76mX84m_gn7lcm.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 76,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900753/polyhouse-foundation_76mX92m_wum6id.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 76,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900752/polyhouse-foundation_76mX100m_bwryqt.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 76,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900743/polyhouse-foundation_76mX108m_xas7uf.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 76,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900742/polyhouse-foundation_76mX116m_dpke0v.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 76,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900742/polyhouse-foundation_76mX124m_iqe6d9.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 76,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900742/polyhouse-foundation_76mX132m_w0hvwn.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 76,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900741/polyhouse-foundation_76mX140m_lr4qir.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 76,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900741/polyhouse-foundation_76mX148m_gyjfjd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 80,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901381/polyhouse-foundation_80mX20m_rr4oh5.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 80,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901380/polyhouse-foundation_80mX28m_etam1x.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 80,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901605/polyhouse-foundation_80mX36m_e9u2gf.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 80,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901375/polyhouse-foundation_80mX44m_heaqp5.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 80,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901373/polyhouse-foundation_80mX52m_kmrua6.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 80,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901372/polyhouse-foundation_80mX60m_f5eqol.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 80,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901365/polyhouse-foundation_80mX68m_dfzwcc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 80,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901364/polyhouse-foundation_80mX76m_a5vqyf.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 80,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901363/polyhouse-foundation_80mX84m_htqjzx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 80,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901358/polyhouse-foundation_80mX92m_xmwam1.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 80,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901357/polyhouse-foundation_80mX100m_ggln5i.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 80,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901349/polyhouse-foundation_80mX108m_zk37y1.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 80,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901346/polyhouse-foundation_80mX116m_lnsfcj.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 80,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901347/polyhouse-foundation_80mX124m_uccgwa.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 80,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901346/polyhouse-foundation_80mX132m_xuonum.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 80,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901346/polyhouse-foundation_80mX140m_myrnfc.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 80,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1760003764/polyhouse-foundation_80mX148m_ezhsk0.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 84,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902953/polyhouse-foundation_84mX20m_yspd2u.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 84,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904248/polyhouse-foundation_84mX28m_tzqfjs.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 84,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902951/polyhouse-foundation_84mX36m_uktmtp.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 84,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902950/polyhouse-foundation_84mX44m_xnxciv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 84,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902946/polyhouse-foundation_84mX52m_fylpbd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 84,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902944/polyhouse-foundation_84mX60m_cx4glx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 84,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904257/polyhouse-foundation_84mX68m_ng9lai.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 84,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902943/polyhouse-foundation_84mX76m_v7axdd.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 84,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902940/polyhouse-foundation_84mX84m_qsvqth.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 84,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902940/polyhouse-foundation_84mX84m_qsvqth.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 84,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902934/polyhouse-foundation_84mX100m_i6giae.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 84,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902933/polyhouse-foundation_84mX108m_eocnyi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 84,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902932/polyhouse-foundation_84mX116m_l9xpyh.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 84,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902926/polyhouse-foundation_84mX124m_onarxm.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 84,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902927/polyhouse-foundation_84mX132m_ymnlpf.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 84,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902926/polyhouse-foundation_84mX140m_lyjjl6.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 84,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902925/polyhouse-foundation_84mX148m_x19ddx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 88,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906660/polyhouse-foundation_88mX20m_p9kkjx.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 88,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906656/polyhouse-foundation_88mX28m_otskic.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 88,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906655/polyhouse-foundation_88mX36m_bipq90.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 88,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906650/polyhouse-foundation_88mX44m_l0goke.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 88,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906649/polyhouse-foundation_88mX52m_utzmyi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 88,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906649/polyhouse-foundation_88mX52m_utzmyi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 88,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906644/polyhouse-foundation_88mX68m_l1vsow.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 88,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906642/polyhouse-foundation_88mX76m_wdpjbi.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 88,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906638/polyhouse-foundation_88mX84m_swpjvq.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 88,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906636/polyhouse-foundation_88mX92m_qohoi2.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 88,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906634/polyhouse-foundation_88mX100m_e4wenl.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 88,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906630/polyhouse-foundation_88mX108m_ph2vta.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 88,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906629/polyhouse-foundation_88mX116m_hm0kc1.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 88,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906622/polyhouse-foundation_88mX124m_yb7qcn.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 88,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906622/polyhouse-foundation_88mX132m_amkzox.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 88,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906621/polyhouse-foundation_88mX140m_gdktov.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 88,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759906621/polyhouse-foundation_88mX148m_dwx8pv.png",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 92,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905861/polyhouse-foundation_92mX20m__compressed_ek6k0l.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 92,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905862/polyhouse-foundation_92mX28m__compressed_vm07bf.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 92,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905862/polyhouse-foundation_92mX36m__compressed_jl4ksh.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 92,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905867/polyhouse-foundation_92mX44m__compressed_qmdubr.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 92,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905868/polyhouse-foundation_92mX52m__compressed_vnjots.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 92,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905871/polyhouse-foundation_92mX60m__compressed_q7usmk.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 92,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905872/polyhouse-foundation_92mX68m__compressed_uvovdi.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 92,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905874/polyhouse-foundation_92mX76m__compressed_pzxgxd.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 92,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905878/polyhouse-foundation_92mX84m__compressed_z3swcs.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 92,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905879/polyhouse-foundation_92mX92m__compressed_bw9ifu.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 92,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905883/polyhouse-foundation_92mX100m__compressed_hvquja.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 92,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905884/polyhouse-foundation_92mX108m__compressed_bskhlu.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 92,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905887/polyhouse-foundation_92mX116m__compressed_jbfejj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 92,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905888/polyhouse-foundation_92mX124m__compressed_tdpt4b.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 92,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905892/polyhouse-foundation_92mX132m__compressed_h4hosp.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 92,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905893/polyhouse-foundation_92mX140m__compressed_b9kee7.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 92,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759905897/polyhouse-foundation_92mX148m__compressed_tioqdl.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 96,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904743/polyhouse-foundation_96mX20m__compressed_hsdf0a.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 96,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904744/polyhouse-foundation_96mX28m__compressed_jhq5sw.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 96,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904744/polyhouse-foundation_96mX36m__compressed_wfvmhp.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 96,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904747/polyhouse-foundation_96mX44m__compressed_lzkjmm.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 96,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904745/polyhouse-foundation_96mX52m__compressed_ojbrkn.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 96,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904753/polyhouse-foundation_96mX60m__compressed_n3o4o0.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 96,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904754/polyhouse-foundation_96mX68m__compressed_jh2kcz.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 96,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904755/polyhouse-foundation_96mX76m__compressed_gtc1qq.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 96,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904761/polyhouse-foundation_96mX84m__compressed_r7ibkw.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 96,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904761/polyhouse-foundation_96mX92m__compressed_wwcwsj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 96,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904764/polyhouse-foundation_96mX100m__compressed_uk95aq.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 96,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904768/polyhouse-foundation_96mX108m__compressed_f7pcgk.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 96,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904769/polyhouse-foundation_96mX116m__compressed_cg1atd.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 96,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904773/polyhouse-foundation_96mX124m__compressed_eamhb2.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 96,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904774/polyhouse-foundation_96mX132m__compressed_zgq3l3.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 96,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904779/polyhouse-foundation_96mX140m__compressed_prnqeg.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 96,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759904780/polyhouse-foundation_96mX148m__compressed_e305qb.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 100,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903253/polyhouse-foundation_100mX20m__compressed_epxese.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 100,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903253/polyhouse-foundation_100mX28m__compressed_brvcvf.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 100,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903254/polyhouse-foundation_100mX36m__compressed_g3bnzx.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 100,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903254/polyhouse-foundation_100mX44m__compressed_loun5f.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 100,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903260/polyhouse-foundation_100mX52m__compressed_vjo0h4.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 100,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903261/polyhouse-foundation_100mX60m__compressed_aji1gv.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 100,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903265/polyhouse-foundation_100mX68m__compressed_fr8gen.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 100,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903266/polyhouse-foundation_100mX76m__compressed_bq0eui.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 100,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903270/polyhouse-foundation_100mX84m__compressed_brt6tj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 100,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903271/polyhouse-foundation_100mX92m__compressed_h1q5wf.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 100,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903275/polyhouse-foundation_100mX100m__compressed_is3zo2.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 100,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903276/polyhouse-foundation_100mX108m__compressed_d4ftb1.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 100,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903276/polyhouse-foundation_100mX116m__compressed_p5txii.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 100,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903281/polyhouse-foundation_100mX124m__compressed_bvjyle.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 100,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903282/polyhouse-foundation_100mX132m__compressed_mnvxdb.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 100,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903275/polyhouse-foundation_100mX100m__compressed_is3zo2.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 100,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759903289/polyhouse-foundation_100mX148m__compressed_bnozup.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 104,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902536/polyhouse-foundation_104mX20m__compressed_xyc7m6.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 104,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902536/polyhouse-foundation_104mX28m__compressed_msdcvt.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 104,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902537/polyhouse-foundation_104mX36m__compressed_dhtw5b.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 104,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902537/polyhouse-foundation_104mX44m__compressed_ewatrd.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 104,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902543/polyhouse-foundation_104mX52m__compressed_gjgkr6.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 104,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902544/polyhouse-foundation_104mX60m__compressed_zekzcu.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 104,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902547/polyhouse-foundation_104mX68m__compressed_u5nf3w.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 104,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902548/polyhouse-foundation_104mX76m__compressed_iya1rb.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 104,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902550/polyhouse-foundation_104mX84m__compressed_mcdbwz.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 104,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902553/polyhouse-foundation_104mX92m__compressed_o9zfzy.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 104,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902556/polyhouse-foundation_104mX100m__compressed_crdoqt.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 104,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902556/polyhouse-foundation_104mX108m__compressed_lrsyzi.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 104,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902559/polyhouse-foundation_104mX116m__compressed_yhbmel.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 104,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902561/polyhouse-foundation_104mX124m__compressed_uxhyk5.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 104,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902563/polyhouse-foundation_104mX132m__compressed_w8rpmy.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 104,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902566/polyhouse-foundation_104mX140m__compressed_bxnsar.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 104,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759902567/polyhouse-foundation_104mX148m__compressed_ecrc90.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 108,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901627/polyhouse-foundation_108mX20m__compressed_cfhglt.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 108,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901628/polyhouse-foundation_108mX28m__compressed_nqafrx.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 108,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901628/polyhouse-foundation_108mX36m__compressed_fyjdit.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 108,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901628/polyhouse-foundation_108mX44m__compressed_znvph3.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 108,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901630/polyhouse-foundation_108mX52m__compressed_iwrsdy.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 108,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901630/polyhouse-foundation_108mX52m__compressed_iwrsdy.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 108,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901637/polyhouse-foundation_108mX68m__compressed_llpwav.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 108,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901637/polyhouse-foundation_108mX76m__compressed_pkfizm.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 108,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901642/polyhouse-foundation_108mX84m__compressed_sgqqhf.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 108,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901643/polyhouse-foundation_108mX92m__compressed_xupxbq.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 108,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901644/polyhouse-foundation_108mX100m__compressed_ja5c5t.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 108,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901647/polyhouse-foundation_108mX108m__compressed_ngiezv.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 108,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901648/polyhouse-foundation_108mX116m__compressed_yqe1hq.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 108,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901648/polyhouse-foundation_108mX116m__compressed_yqe1hq.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 108,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901652/polyhouse-foundation_108mX132m__compressed_txg3vx.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 108,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901653/polyhouse-foundation_108mX140m__compressed_sdldok.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 108,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759901657/polyhouse-foundation_108mX148m__compressed_v67lfe.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 112,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900867/polyhouse-foundation_112mX20m__compressed_tt6olc.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 112,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900868/polyhouse-foundation_112mX28m__compressed_qgxapq.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 112,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900869/polyhouse-foundation_112mX36m__compressed_xrbs6g.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 112,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900868/polyhouse-foundation_112mX44m__compressed_xtyugv.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 112,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900869/polyhouse-foundation_112mX52m__compressed_kzkuxs.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 112,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900869/polyhouse-foundation_112mX60m__compressed_aqfooe.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 112,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900877/polyhouse-foundation_112mX68m__compressed_driuau.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 112,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900878/polyhouse-foundation_112mX76m__compressed_s8je6x.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 112,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900878/polyhouse-foundation_112mX84m__compressed_stxocm.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 112,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900883/polyhouse-foundation_112mX92m__compressed_eca9u8.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 112,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900883/polyhouse-foundation_112mX100m__compressed_srvagl.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 112,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900885/polyhouse-foundation_112mX108m__compressed_io8egs.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 112,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900889/polyhouse-foundation_112mX116m__compressed_xztkmj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 112,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900889/polyhouse-foundation_112mX124m__compressed_nsilcj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 112,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900892/polyhouse-foundation_112mX132m__compressed_gvuumr.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 112,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900895/polyhouse-foundation_112mX140m__compressed_darwuc.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 112,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900896/polyhouse-foundation_112mX148m__compressed_e2tcze.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 116,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900115/polyhouse-foundation_116mX20m__compressed_xhznia.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 116,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900115/polyhouse-foundation_116mX28m__compressed_ghrkmk.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 116,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900116/polyhouse-foundation_116mX36m__compressed_woyt0n.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 116,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900116/polyhouse-foundation_116mX44m__compressed_rkxcol.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 116,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900116/polyhouse-foundation_116mX44m__compressed_rkxcol.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 116,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900117/polyhouse-foundation_116mX60m__compressed_n9tiiv.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 116,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900124/polyhouse-foundation_116mX68m__compressed_akjpxu.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 116,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900124/polyhouse-foundation_116mX76m__compressed_yrqeri.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 116,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900126/polyhouse-foundation_116mX84m__compressed_hcbc7x.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 116,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900129/polyhouse-foundation_116mX92m__compressed_d6h1fc.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 116,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900130/polyhouse-foundation_116mX100m__compressed_iuwe7v.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 116,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900132/polyhouse-foundation_116mX108m__compressed_lsqekx.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 116,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900135/polyhouse-foundation_116mX116m__compressed_rlyhaz.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 116,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900136/polyhouse-foundation_116mX124m__compressed_sxdnpe.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 116,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900137/polyhouse-foundation_116mX132m__compressed_aelfxj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 116,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900141/polyhouse-foundation_116mX140m__compressed_wgx2ah.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 116,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759900141/polyhouse-foundation_116mX148m__compressed_h0samf.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 120,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898873/polyhouse-foundation_120mX20m__compressed_nymh8b.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 120,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898874/polyhouse-foundation_120mX28m__compressed_fgev2f.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 120,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898874/polyhouse-foundation_120mX36m__compressed_vfyhmo.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 120,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898874/polyhouse-foundation_120mX44m__compressed_tclysx.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 120,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898875/polyhouse-foundation_120mX52m__compressed_qqzjmf.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 120,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898874/polyhouse-foundation_120mX60m__compressed_zngl0n.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 120,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898875/polyhouse-foundation_120mX68m__compressed_dfminj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 120,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898876/polyhouse-foundation_120mX76m__compressed_hgrw7f.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 120,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898885/polyhouse-foundation_120mX84m__compressed_awcefi.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 120,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898886/polyhouse-foundation_120mX92m__compressed_jaz8ci.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 120,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898886/polyhouse-foundation_120mX100m__compressed_d95ujb.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 120,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898887/polyhouse-foundation_120mX108m__compressed_npcdbx.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 120,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898892/polyhouse-foundation_120mX116m__compressed_mgiqmz.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 120,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898893/polyhouse-foundation_120mX124m__compressed_jelvwi.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 120,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898893/polyhouse-foundation_120mX132m__compressed_g8dqxt.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 120,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898895/polyhouse-foundation_120mX140m__compressed_cirwho.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 120,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898898/polyhouse-foundation_120mX148m__compressed_hk2o8j.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 124,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898033/polyhouse-foundation_124mX20m__compressed_sewnao.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 124,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898033/polyhouse-foundation_124mX28m__compressed_ggoue8.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 124,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898033/polyhouse-foundation_124mX36m__compressed_tvbh4z.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 124,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898033/polyhouse-foundation_124mX44m__compressed_fim7qj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 124,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898034/polyhouse-foundation_124mX52m__compressed_cubikt.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 124,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898033/polyhouse-foundation_124mX60m__compressed_yog3fi.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 124,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898034/polyhouse-foundation_124mX68m__compressed_sw2u1y.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 124,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898034/polyhouse-foundation_124mX76m__compressed_wswg5y.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 124,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898044/polyhouse-foundation_124mX84m__compressed_jiggtk.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 124,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898044/polyhouse-foundation_124mX92m__compressed_xz89vq.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 124,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898045/polyhouse-foundation_124mX100m__compressed_cejtey.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 124,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898045/polyhouse-foundation_124mX108m__compressed_ts5tly.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 124,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898050/polyhouse-foundation_124mX116m__compressed_txtazc.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 124,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898051/polyhouse-foundation_124mX124m__compressed_ad5x3h.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 124,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898052/polyhouse-foundation_124mX132m__compressed_acvxhs.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 124,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898056/polyhouse-foundation_124mX140m__compressed_dll61r.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 124,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759898057/polyhouse-foundation_124mX148m__compressed_rzhj9x.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 128,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896848/polyhouse-foundation_128mX20m__compressed_riydn8.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 128,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896848/polyhouse-foundation_128mX28m__compressed_ns5olo.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 128,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896849/polyhouse-foundation_128mX36m__compressed_vzthmh.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 128,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896849/polyhouse-foundation_128mX44m__compressed_onejos.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 128,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896849/polyhouse-foundation_128mX52m__compressed_aiao91.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 128,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896849/polyhouse-foundation_128mX60m__compressed_djsqpn.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 128,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896849/polyhouse-foundation_128mX68m__compressed_fr5wwa.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 128,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896848/polyhouse-foundation_128mX76m__compressed_hggkpu.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 128,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896848/polyhouse-foundation_128mX76m__compressed_hggkpu.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 128,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896849/polyhouse-foundation_128mX92m__compressed_jqpmjl.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 128,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896850/polyhouse-foundation_128mX100m__compressed_qpohvj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 128,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896850/polyhouse-foundation_128mX108m__compressed_f7rp7e.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 128,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896850/polyhouse-foundation_128mX116m__compressed_wjyg1m.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 128,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896850/polyhouse-foundation_128mX124m__compressed_ptie1x.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 128,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896850/polyhouse-foundation_128mX132m__compressed_ur9gmg.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 128,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896850/polyhouse-foundation_128mX140m__compressed_lhe1i1.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 128,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759896850/polyhouse-foundation_128mX148m__compressed_brdxsm.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 132,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838809/polyhouse-foundation_132mX20m__compressed_inhjuz.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 132,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838809/polyhouse-foundation_132mX28m__compressed_lzxpvs.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 132,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838810/polyhouse-foundation_132mX36m__compressed_p8wbby.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 132,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838810/polyhouse-foundation_132mX44m__compressed_lqsclb.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 132,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838811/polyhouse-foundation_132mX52m__compressed_e2q0ag.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 132,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838811/polyhouse-foundation_132mX52m__compressed_e2q0ag.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 132,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838819/polyhouse-foundation_132mX68m__compressed_xpwkyu.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 132,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838819/polyhouse-foundation_132mX76m__compressed_fkfpex.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 132,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838821/polyhouse-foundation_132mX84m__compressed_tgy8xv.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 132,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838822/polyhouse-foundation_132mX92m__compressed_deneu8.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 132,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838826/polyhouse-foundation_132mX100m__compressed_nhbcft.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 132,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838827/polyhouse-foundation_132mX108m__compressed_m9ljgu.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 132,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838828/polyhouse-foundation_132mX116m__compressed_rehc2t.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 132,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838835/polyhouse-foundation_132mX124m__compressed_bekizr.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 132,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838834/polyhouse-foundation_132mX132m__compressed_qmtyna.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 132,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759838835/polyhouse-foundation_132mX140m__compressed_wplbvp.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 132,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759839321/polyhouse-foundation_132mX148m__compressed_kb5a6n.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 136,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836785/polyhouse-foundation_136mX20m__compressed_wdu3tr.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 136,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836786/polyhouse-foundation_136mX28m__compressed_z6xsho.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 136,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836789/polyhouse-foundation_136mX36m__compressed_jacga0.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 136,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836789/polyhouse-foundation_136mX36m__compressed_jacga0.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 136,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836787/polyhouse-foundation_136mX52m__compressed_gi4vib.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 136,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836798/polyhouse-foundation_136mX60m__compressed_sf0fxh.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 136,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836795/polyhouse-foundation_136mX68m__compressed_jyzk3o.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 136,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836798/polyhouse-foundation_136mX76m__compressed_hiuujz.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 136,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836798/polyhouse-foundation_136mX84m__compressed_bydxez.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 136,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836799/polyhouse-foundation_136mX92m__compressed_ewlvmb.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 136,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836804/polyhouse-foundation_136mX100m__compressed_eeppm5.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 136,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836808/polyhouse-foundation_136mX108m__compressed_o1xw9j.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 136,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836807/polyhouse-foundation_136mX116m__compressed_ymms9w.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 136,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836808/polyhouse-foundation_136mX124m__compressed_a3g1g2.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 136,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836809/polyhouse-foundation_136mX132m__compressed_ygn9fd.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 136,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836814/polyhouse-foundation_136mX140m__compressed_k7ladm.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 136,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759836817/polyhouse-foundation_136mX148m__compressed_tnp979.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 140,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835798/polyhouse-foundation_140mX20m__compressed_exa5m0.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 140,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835798/polyhouse-foundation_140mX28m__compressed_qt87wi.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 140,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835798/polyhouse-foundation_140mX36m__compressed_dgder8.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 140,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835798/polyhouse-foundation_140mX44m__compressed_dp02jy.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 140,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835798/polyhouse-foundation_140mX52m__compressed_azjslj.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 140,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835799/polyhouse-foundation_140mX60m__compressed_qxrgle.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 140,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835799/polyhouse-foundation_140mX68m__compressed_vhuzft.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 140,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835800/polyhouse-foundation_140mX76m__compressed_ymgm0s.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 140,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835800/polyhouse-foundation_140mX76m__compressed_ymgm0s.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 140,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835811/polyhouse-foundation_140mX92m__compressed_yczsmn.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 140,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835813/polyhouse-foundation_140mX100m__compressed_xflwwe.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 140,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835814/polyhouse-foundation_140mX108m__compressed_ttjq3x.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 140,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835816/polyhouse-foundation_140mX116m__compressed_rceueb.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 140,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835822/polyhouse-foundation_140mX124m__compressed_dlng2m.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 140,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835822/polyhouse-foundation_140mX132m__compressed_zp8rhm.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 140,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835822/polyhouse-foundation_140mX140m__compressed_wkyp7a.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 140,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759835825/polyhouse-foundation_140mX148m__compressed_eowt1z.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 144,
    width: 20,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759833046/polyhouse-foundation_144mX20m__compressed_zva6ew.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742390/polyhouse-end-view_qe0yrq.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742389/polyhouse-side-view_v8t5xq.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742388/polyhouse-center-view_uqv603.png",
    },
  },
  {
    length: 144,
    width: 28,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834352/polyhouse-foundation_144mX28m__compressed_gmvsav.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742526/polyhouse-end-view_sbksb6.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-center-view_rifaoa.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742528/polyhouse-side-view_rdmgeo.png",
    },
  },
  {
    length: 144,
    width: 36,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834354/polyhouse-foundation_144mX36m__compressed_bwujt1.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742971/polyhouse-end-view_ahfqdd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742809/polyhouse-side-view_ifildh.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 144,
    width: 44,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834355/polyhouse-foundation_144mX44m__compressed_hfk93d.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743166/polyhouse-center-view_opanei.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743092/polyhouse-side-view_cxks20.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759742808/polyhouse-center-view_uewbwx.png",
    },
  },
  {
    length: 144,
    width: 52,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834353/polyhouse-foundation_144mX52m__compressed_rda6qa.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743366/polyhouse-end-view_kyprcx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-side-view_m7uctj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743367/polyhouse-center-view_ltbkzh.png",
    },
  },
  {
    length: 144,
    width: 60,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834357/polyhouse-foundation_144mX60m__compressed_g4futw.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743717/polyhouse-end-view_ysugkv.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743679/polyhouse-side-view_ztq2ll.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743715/polyhouse-center-view_rwh0mu.png",
    },
  },
  {
    length: 144,
    width: 68,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834353/polyhouse-foundation_144mX68m__compressed_ivvke5.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759743871/polyhouse-side-view_tbwx1b.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 144,
    width: 76,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834354/polyhouse-foundation_144mX76m__compressed_kjn9xu.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-end-view_d6wjlx.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759745553/polyhouse-side-view_3_aqjvgu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759744258/polyhouse-center-view_ued4te.png",
    },
  },
  {
    length: 144,
    width: 84,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834356/polyhouse-foundation_144mX84m__compressed_j0gfsf.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746188/polyhouse-end-view_rdmefz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746488/polyhouse-side-view_2_tm7yzj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759746187/polyhouse-center-view_znootc.png",
    },
  },
  {
    length: 144,
    width: 92,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834355/polyhouse-foundation_144mX92m__compressed_ipwlq8.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-end-view_c1x9rd.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748039/polyhouse-side-view_1_gglof1.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748036/polyhouse-center-view_bm3iuf.png",
    },
  },
  {
    length: 144,
    width: 100,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834359/polyhouse-foundation_144mX100m__compressed_fciido.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748279/polyhouse-end-view_d2eqp9.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748364/polyhouse-side-view_1_q67xmu.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748278/polyhouse-center-view_ii0ejw.png",
    },
  },
  {
    length: 144,
    width: 108,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834376/polyhouse-foundation_144mX108m__compressed_qcykyq.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748961/polyhouse-end-view_oqqksz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749034/polyhouse-side-view_1_ahkuqr.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759748959/polyhouse-center-view_zm0frz.png",
    },
  },
  {
    length: 144,
    width: 116,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834376/polyhouse-foundation_144mX108m__compressed_qcykyq.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749484/polyhouse-end-view_uzwy1g.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749486/polyhouse-side-view_1_xzsttj.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749483/polyhouse-center-view_qqra1j.png",
    },
  },
  {
    length: 144,
    width: 124,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834370/polyhouse-foundation_144mX124m__compressed_ch0ypf.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749918/polyhouse-end-view_q40eyz.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749921/polyhouse-side-view_1_krlht8.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759749917/polyhouse-center-view_nsfvxy.png",
    },
  },
  {
    length: 144,
    width: 132,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834369/polyhouse-foundation_144mX132m__compressed_ffjo7n.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750335/polyhouse-end-view_rp4cvu.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750339/polyhouse-side-view_1_j34iuz.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759750334/polyhouse-center-view_a1xf5r.png",
    },
  },
  {
    length: 144,
    width: 140,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834373/polyhouse-foundation_144mX140m__compressed_wv0d0v.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
  {
    length: 144,
    width: 148,
    images: {
      foundImg:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759834370/polyhouse-foundation_144mX148m__compressed_dwieg9.jpg",
      endView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751040/polyhouse-end-view_b0wopp.png",
      sideView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751043/polyhouse-side-view_1_xsanjo.png",
      centerView:
        "https://res.cloudinary.com/bsgfcooa/image/upload/v1759751039/polyhouse-center-view_ensjji.png",
    },
  },
];
